import { render, staticRenderFns } from "./compareBomVersion.vue?vue&type=template&id=28d78de7&scoped=true&"
import script from "./compareBomVersion.vue?vue&type=script&lang=js&"
export * from "./compareBomVersion.vue?vue&type=script&lang=js&"
import style0 from "./compareBomVersion.vue?vue&type=style&index=0&id=28d78de7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d78de7",
  null
  
)

export default component.exports